module.exports = __webpack_public_path__ + "static/leadership-34cca207226c96e4b005edffb57c4e8a.jpg";